import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomModal from '../../../../../shared/CustomModal/CustomModal';
import CustomCard from '../../../../../shared/CustomCard/CustomCard';
import CustomButton from '../../../../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../../../../theme/Color';

interface DeleteConfirmationModalProps {
  open: boolean;
  userName?: string | null;
  userCount?: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  userName,
  userCount,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <CustomModal handleClose={onCancel} open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '375px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              Delete User{userCount && userCount > 1 ? 's' : ''}
            </Typography>

            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              {userCount && userCount > 1 ? (
                <>
                  You're about to delete{' '}
                  <Typography
                    variant='responsiveBody3'
                    component='span'
                    color={zeplinColor.BasicBlack}
                    fontWeight={600}
                  >
                    {userCount} users
                  </Typography>{' '}
                  from the Huddle. Their access will be removed. This action cannot be undone. Are
                  you sure you want to delete?
                </>
              ) : (
                <>
                  You're about to delete{' '}
                  <Typography
                    variant='responsiveBody3'
                    component='span'
                    color={zeplinColor.BasicBlack}
                    fontWeight={600}
                  >
                    {userName}
                  </Typography>{' '}
                  from the Huddle. Their access will be removed. This action cannot be undone. Are
                  you sure you want to delete?
                </>
              )}
            </Typography>

            <Box
              sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}
            >
              <CustomButton
                disabled={loading}
                onClick={onCancel}
                variant='outlined'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  flex: 1,
                  border: `1px solid ${zeplinColor.BasicBlack}`,
                  '&.hover': {
                    backgroundColor: zeplinColor.Neutral3,
                  },
                }}
                textStyle={{ color: zeplinColor.BasicBlack }}
                text='Cancel'
              />
              <CustomButton
                disabled={loading}
                onClick={onConfirm}
                variant='contained'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Error,
                  flex: 1,
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={loading ? 'Deleting...' : 'Delete'}
              />
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default DeleteConfirmationModal;
